export default __webpack_public_path__ + "static/jetson_one_background_mobile-dbc0c87cd01c85a73660169a66001f6d.mp4";